module.exports = __webpack_public_path__ + "media/whoosh.38b50400.mp3";